import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell,
} from '@mui/material';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../styles/MyStyles";
import {GetLookupMenuItems} from "../../logic/LookupHelper";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {GetEnumMenuItems} from "../../logic/EnumHelper";
import {GetCookieInfo} from "../../logic/CookieManager";
import {TransformDecimalFields} from "../../logic/OrderFieldsHeleper";
import * as DataProvider from "../../logic/DataProvider";

const OrderRequestPage = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [request, setRequest] = useState({
        contactId: DataProvider.GetClientBundle().contact.id,
        createdDate: dayjs().toISOString(),
        expirationDate: '',
        action: 0,
        type: 1,
        status: 0,
        cryptoAmountRequested: '',
        requestedPrice: '',
        sellAssetId: '',
        buyAssetId: ''
    });

    useEffect(() => {
    }, []);

    const validateForm = () => {
        let newErrors = {};

        if (request.expirationDate === '') {
            newErrors.expirationDate = 'Expiration Date is required.';
        }


        if (request.cryptoAmountRequested === '') {
            newErrors.cryptoAmountRequested = 'Crypto Amount Requested is required.';
        } else if (isNaN(request.cryptoAmountRequested)) {
            newErrors.cryptoAmountRequested = 'Crypto Amount Requested must be number.';
        }
        if (request.type === 0) {
            if (request.requestedPrice === '') {
                newErrors.requestedPrice = 'Requested Price is required.';
            } else if (isNaN(request.requestedPrice)) {
                newErrors.requestedPrice = 'Requested Price must be number.';
            }
        }

        if (request.sellAssetId === '') {
            newErrors.sellAssetId = 'Sell Asset is required.';
        }
        if (request.buyAssetId === '') {
            newErrors.buyAssetId = 'Buy Asset is required.';
        }

        return newErrors;
    };

    const handleFieldChange = (event) => {
        if (event.target.name === 'action') {
            request.sellAssetId = '';
            request.buyAssetId = '';
        }

        if (event.target.name === 'type' && event.target.value !== 0) {
            request.requestedPrice = '';
        }

        setRequest({
            ...request,
            [event.target.name]: event.target.value,
        });
    };

    const handleSendRequest = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_ORDERS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(TransformDecimalFields(request)),
                }
            );
            if (response.ok) {
                console.log('Order created successfully.');

                const data = await response.json();

                let bundle = DataProvider.GetClientBundle();
                if (bundle.orders) {
                    bundle.orders.push(data.data);
                } else {
                    bundle.orders = [data.data];
                }
                if (bundle.dashboard.orders) {
                    bundle.dashboard.orders.push(data.data);
                } else {
                    bundle.dashboard.orders = [data.data];
                }

                handleGoBack();
            } else {
                console.log('Update order failed.');
            }

        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                New Order Request
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSendRequest}>
                    Send request
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Expiration Date</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <DatePicker
                                timezone="UTC"
                                name="expirationDate"
                                label="Expiration Date"
                                value={dayjs(request.expirationDate)}
                                onChange={(date) =>  {
                                    let event = {
                                        'target': {
                                            'name': 'expirationDate',
                                            'value': date.toJSON()
                                        }
                                    };
                                    handleFieldChange(event);
                                }
                                }
                                fullWidth
                                size='small'
                                slotProps={{
                                    textField: {
                                        required: true,
                                    },
                                }}
                                error={!!errors.expirationDate}
                                helperText={errors.expirationDate}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Action</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="action"
                                label="Action"
                                select
                                value={request.action}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.action}
                                helperText={errors.action}
                            >
                                {GetEnumMenuItems('orderAction')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Type</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="type"
                                label="Type"
                                select
                                value={request.type}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.type}
                                helperText={errors.type}
                            >
                                {GetEnumMenuItems('orderType')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Sell Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="sellAssetId"
                                label="Sell Asset"
                                select
                                value={request.sellAssetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.sellAssetId}
                                helperText={errors.sellAssetId}
                            >
                                {GetLookupMenuItems('asset')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Buy Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="buyAssetId"
                                label="Buy Asset"
                                select
                                value={request.buyAssetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.buyAssetId}
                                helperText={errors.buyAssetId}
                            >
                                {GetLookupMenuItems('asset')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Crypto Amount Requested</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="cryptoAmountRequested"
                                label="Crypto Amount Requested"
                                value={request.cryptoAmountRequested}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.cryptoAmountRequested}
                                helperText={errors.cryptoAmountRequested}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Requested Price</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="requestedPrice"
                                label="Requested Price"
                                value={request.requestedPrice}
                                onChange={handleFieldChange}
                                fullWidth
                                disabled={request.type !== 0}
                                required={request.type === 0}
                                error={!!errors.requestedPrice}
                                helperText={errors.requestedPrice}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default OrderRequestPage;
